import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumb({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400" data-testid="breadcrumb">
      <Link to="/" className="flex items-center hover:text-slate-900 dark:hover:text-white transition-colors">
        <Home size={12} />
      </Link>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <ChevronRight size={12} className="text-slate-300 dark:text-slate-600" />
          {it.to ? (
            <Link to={it.to} className="hover:text-slate-900 dark:hover:text-white transition-colors">{it.label}</Link>
          ) : (
            <span className="text-slate-900 dark:text-white font-medium">{it.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
